import styles from './LoaderButton.module.scss';

export default function LoaderButton() {
    return <div className={styles.loader}></div>;
}
